export default __webpack_public_path__ + "static/media/Devin Nunes.62c76622.jpg";